import * as React from 'react';
import { connect } from 'react-redux';
import { cx } from 'linaria';
import { Breadcrumbs, BreadcrumbsItem } from 'fronton-react';
import type { RootState } from 'typesafe-actions';

import { pdpSectionStyle } from 'common/components/page-section';
import { getBreadcrumbsWithCurrentPageLink } from 'features/review-form/ducks';

import type { Breadcrumb } from 'types/page-model';
import type { HTMLAttributes, CommonlyExcludedHTMLAttributeNames } from 'types/utils';

type AcceptedHTMLAttributes = Omit<HTMLAttributes, CommonlyExcludedHTMLAttributeNames>;
export type PdpReviewFormBreadcrumbsProps = AcceptedHTMLAttributes;

type ReviewFormBreadcrumbsMappedState = {
  breadcrumbs: Breadcrumb[];
};
type ReviewFormBreadcrumbsConnectedProps = ReviewFormBreadcrumbsMappedState;

/**
 * @internal Used only for tests
 */
export const ReviewFormBreadcrumbs: React.FC<
  PdpReviewFormBreadcrumbsProps & ReviewFormBreadcrumbsConnectedProps
> = ({ breadcrumbs, className, ...htmlProps }) => {
  return (
    <nav data-qa="breadcrumbs" className={cx(pdpSectionStyle, className)} {...htmlProps}>
      <Breadcrumbs addSEOAttributes={false}>
        {breadcrumbs.map((item, i, arr) => (
          <BreadcrumbsItem
            aria-current={i === arr.length - 1 ? 'page' : undefined}
            key={item.link}
            href={item.link}
          >
            {item.label}
          </BreadcrumbsItem>
        ))}
      </Breadcrumbs>
    </nav>
  );
};

function mapStateToProps(state: RootState): ReviewFormBreadcrumbsMappedState {
  return {
    breadcrumbs: getBreadcrumbsWithCurrentPageLink(state),
  };
}

export const PdpReviewFormBreadcrumbs = connect(mapStateToProps)(ReviewFormBreadcrumbs);
